import { cn } from "@/lib/utils";

function SkeletonBar({ className }: { className?: string }) {
  return <div className={cn("animate-pulse rounded bg-gray-200", className)} />;
}

export function MedGroupCardSkeleton() {
  return (
    <div className="overflow-clip rounded-md border bg-white">
      {/* Header */}
      <div className="flex items-center gap-3 border-b px-4 py-3">
        <SkeletonBar className="h-5 w-16 rounded-full" />
        <SkeletonBar className="h-5 w-48" />
        <div className="ml-auto flex gap-2">
          <SkeletonBar className="h-5 w-14 rounded-full" />
          <SkeletonBar className="h-5 w-14 rounded-full" />
        </div>
      </div>

      {/* Table header */}
      <div className="grid grid-cols-[1fr_repeat(3,80px)] gap-2 border-b px-4 py-2 md:grid-cols-[20fr_repeat(3,12fr)_repeat(4,7fr)_16fr]">
        {Array.from({ length: 5 }).map((_, i) => (
          <SkeletonBar key={i} className="h-3 w-full" />
        ))}
      </div>

      {/* Table rows */}
      {Array.from({ length: 2 }).map((_, row) => (
        <div
          key={row}
          className="grid grid-cols-[1fr_repeat(3,80px)] gap-2 border-b px-4 py-3 last:border-b-0 md:grid-cols-[20fr_repeat(3,12fr)_repeat(4,7fr)_16fr]"
        >
          {Array.from({ length: 5 }).map((_, i) => (
            <SkeletonBar key={i} className="h-4 w-full" />
          ))}
        </div>
      ))}
    </div>
  );
}

export function SimpleMedGroupCardSkeleton() {
  return (
    <div className="border border-t-0 bg-white px-4 py-3 first:rounded-t-md first:border-t last:rounded-b-md">
      <div className="flex items-center gap-2">
        <SkeletonBar className="h-5 w-16 rounded-full" />
        <SkeletonBar className="h-5 w-40" />
        <div className="ml-auto flex gap-2">
          <SkeletonBar className="h-5 w-14 rounded-full" />
        </div>
      </div>
    </div>
  );
}

export function MedGroupListSkeleton({ count = 20 }: { count?: number }) {
  if (count === 20) {
    return (
      <div className="flex flex-col gap-0">
        {Array.from({ length: count }).map((_, i) => (
          <SimpleMedGroupCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <MedGroupCardSkeleton key={i} />
      ))}
    </div>
  );
}
